import type { VisualizationProps } from './types';

/**
 * OtherSVG — generic мебельный модуль (fallback для нестандартных категорий
 * через админ-панель Phase 9+).
 * Зоны: facade, corpus, handles, countertop. Без hooks. Конвенции — `./types.ts`.
 */
export function OtherSVG({
  facadeColor,
  countertopColor,
  corpusColor,
  handlesColor,
}: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      <rect
        data-testid="zone-countertop"
        x="60"
        y="50"
        width="200"
        height="12"
        fill={countertopColor}
        stroke="#000000"
        strokeWidth="1"
      />
      <rect
        data-testid="zone-corpus"
        x="60"
        y="62"
        width="200"
        height="123"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="68"
        y="70"
        width="184"
        height="107"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="155"
        y="120"
        width="10"
        height="2"
        fill={handlesColor}
        rx="1"
      />
      <text
        x="160"
        y="140"
        textAnchor="middle"
        fontSize="10"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="50"
        y="125"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
      <text
        x="160"
        y="48"
        textAnchor="middle"
        fontSize="8"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        3
      </text>
    </svg>
  );
}
